import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/src/styles/main.sass'
import 'vuetify/src/styles/styles.sass'
import { tr } from 'vuetify/es5/locale'

Vue.use(Vuetify)

// Types
// const { preset } = require('vuetify/es5/presets/default')
// console.warn(preset, 'preset')

export const preset = {
    breakpoint: {
        scrollBarWidth: 16,
        thresholds: {
            xs: 600,
            sm: 960,
            md: 1280,
            lg: 1920,
        },
    },
    icons: {
        iconfont: 'mdi',
        values: {},
    },
    lang: {
        current: 'tr',
        locales: { tr },
        t: undefined,
    },
    rtl: false,
    theme: {
        dark: false,
        default: 'light',
        disable: false,
        options: {
            cspNonce: undefined,
            customProperties: undefined,
            minifyTheme: undefined,
            themeCache: undefined,
        },
        themes: {
            light: {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
            },
            dark: {
                primary: '#2196F3',
                secondary: '#424242',
                accent: '#FF4081',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
            },
        },
    },
};

const opts = {
    preset,
    theme: { dark: false },
};

export default new Vuetify(opts);
